/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetPizzaById200,
  GetPizzaById404,
  GetPizzaById500,
  PostAggregatePizzas200,
  PostAggregatePizzas500,
  PostAggregatePizzasBody,
  PostEvaluatePizzaAdvanced200,
  PostEvaluatePizzaAdvanced404,
  PostEvaluatePizzaAdvanced500,
  PostEvaluatePizzaAdvancedBody,
  PostGetAllPizzas200,
  PostGetAllPizzas500,
  PostGetAllPizzasBody,
  PostGetNextPizza200,
  PostGetNextPizza500,
  PostGetNextPizzaBody,
  PostGetPrevPizza200,
  PostGetPrevPizza500,
  PostGetPrevPizzaBody,
  PostPizzasCount200,
  PostPizzasCount500,
  PostPizzasCountBody,
} from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postGetAllPizzas = (
  postGetAllPizzasBody: BodyType<PostGetAllPizzasBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostGetAllPizzas200>(
    {
      url: `/api/admin/pizzas/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetAllPizzasBody,
      signal,
    },
    options,
  );
};

export const getPostGetAllPizzasQueryKey = (
  postGetAllPizzasBody: PostGetAllPizzasBody,
) => {
  return [`/api/admin/pizzas/`, postGetAllPizzasBody] as const;
};

export const getPostGetAllPizzasQueryOptions = <
  TData = Awaited<ReturnType<typeof postGetAllPizzas>>,
  TError = ErrorType<PostGetAllPizzas500>,
>(
  postGetAllPizzasBody: PostGetAllPizzasBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllPizzas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPostGetAllPizzasQueryKey(postGetAllPizzasBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postGetAllPizzas>>
  > = ({ signal }) =>
    postGetAllPizzas(postGetAllPizzasBody, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postGetAllPizzas>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostGetAllPizzasQueryResult = NonNullable<
  Awaited<ReturnType<typeof postGetAllPizzas>>
>;
export type PostGetAllPizzasQueryError = ErrorType<PostGetAllPizzas500>;

export function usePostGetAllPizzas<
  TData = Awaited<ReturnType<typeof postGetAllPizzas>>,
  TError = ErrorType<PostGetAllPizzas500>,
>(
  postGetAllPizzasBody: PostGetAllPizzasBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllPizzas>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetAllPizzas>>,
          TError,
          Awaited<ReturnType<typeof postGetAllPizzas>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetAllPizzas<
  TData = Awaited<ReturnType<typeof postGetAllPizzas>>,
  TError = ErrorType<PostGetAllPizzas500>,
>(
  postGetAllPizzasBody: PostGetAllPizzasBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllPizzas>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetAllPizzas>>,
          TError,
          Awaited<ReturnType<typeof postGetAllPizzas>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetAllPizzas<
  TData = Awaited<ReturnType<typeof postGetAllPizzas>>,
  TError = ErrorType<PostGetAllPizzas500>,
>(
  postGetAllPizzasBody: PostGetAllPizzasBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllPizzas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostGetAllPizzas<
  TData = Awaited<ReturnType<typeof postGetAllPizzas>>,
  TError = ErrorType<PostGetAllPizzas500>,
>(
  postGetAllPizzasBody: PostGetAllPizzasBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllPizzas>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostGetAllPizzasQueryOptions(
    postGetAllPizzasBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postAggregatePizzas = (
  postAggregatePizzasBody: BodyType<PostAggregatePizzasBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostAggregatePizzas200>(
    {
      url: `/api/admin/pizzas/aggregate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postAggregatePizzasBody,
      signal,
    },
    options,
  );
};

export const getPostAggregatePizzasMutationOptions = <
  TError = ErrorType<PostAggregatePizzas500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAggregatePizzas>>,
    TError,
    { data: BodyType<PostAggregatePizzasBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAggregatePizzas>>,
  TError,
  { data: BodyType<PostAggregatePizzasBody> },
  TContext
> => {
  const mutationKey = ["postAggregatePizzas"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAggregatePizzas>>,
    { data: BodyType<PostAggregatePizzasBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAggregatePizzas(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAggregatePizzasMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAggregatePizzas>>
>;
export type PostAggregatePizzasMutationBody = BodyType<PostAggregatePizzasBody>;
export type PostAggregatePizzasMutationError =
  ErrorType<PostAggregatePizzas500>;

export const usePostAggregatePizzas = <
  TError = ErrorType<PostAggregatePizzas500>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAggregatePizzas>>,
      TError,
      { data: BodyType<PostAggregatePizzasBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAggregatePizzas>>,
  TError,
  { data: BodyType<PostAggregatePizzasBody> },
  TContext
> => {
  const mutationOptions = getPostAggregatePizzasMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postPizzasCount = (
  postPizzasCountBody: BodyType<PostPizzasCountBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostPizzasCount200>(
    {
      url: `/api/admin/pizzas/count`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postPizzasCountBody,
      signal,
    },
    options,
  );
};

export const getPostPizzasCountMutationOptions = <
  TError = ErrorType<PostPizzasCount500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPizzasCount>>,
    TError,
    { data: BodyType<PostPizzasCountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPizzasCount>>,
  TError,
  { data: BodyType<PostPizzasCountBody> },
  TContext
> => {
  const mutationKey = ["postPizzasCount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPizzasCount>>,
    { data: BodyType<PostPizzasCountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postPizzasCount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPizzasCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPizzasCount>>
>;
export type PostPizzasCountMutationBody = BodyType<PostPizzasCountBody>;
export type PostPizzasCountMutationError = ErrorType<PostPizzasCount500>;

export const usePostPizzasCount = <
  TError = ErrorType<PostPizzasCount500>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPizzasCount>>,
      TError,
      { data: BodyType<PostPizzasCountBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPizzasCount>>,
  TError,
  { data: BodyType<PostPizzasCountBody> },
  TContext
> => {
  const mutationOptions = getPostPizzasCountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postEvaluatePizzaAdvanced = (
  postEvaluatePizzaAdvancedBody: BodyType<PostEvaluatePizzaAdvancedBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostEvaluatePizzaAdvanced200>(
    {
      url: `/api/admin/pizzas/evaluate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postEvaluatePizzaAdvancedBody,
      signal,
    },
    options,
  );
};

export const getPostEvaluatePizzaAdvancedMutationOptions = <
  TError = ErrorType<
    PostEvaluatePizzaAdvanced404 | PostEvaluatePizzaAdvanced500
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>,
    TError,
    { data: BodyType<PostEvaluatePizzaAdvancedBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>,
  TError,
  { data: BodyType<PostEvaluatePizzaAdvancedBody> },
  TContext
> => {
  const mutationKey = ["postEvaluatePizzaAdvanced"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>,
    { data: BodyType<PostEvaluatePizzaAdvancedBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postEvaluatePizzaAdvanced(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostEvaluatePizzaAdvancedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>
>;
export type PostEvaluatePizzaAdvancedMutationBody =
  BodyType<PostEvaluatePizzaAdvancedBody>;
export type PostEvaluatePizzaAdvancedMutationError = ErrorType<
  PostEvaluatePizzaAdvanced404 | PostEvaluatePizzaAdvanced500
>;

export const usePostEvaluatePizzaAdvanced = <
  TError = ErrorType<
    PostEvaluatePizzaAdvanced404 | PostEvaluatePizzaAdvanced500
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>,
      TError,
      { data: BodyType<PostEvaluatePizzaAdvancedBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postEvaluatePizzaAdvanced>>,
  TError,
  { data: BodyType<PostEvaluatePizzaAdvancedBody> },
  TContext
> => {
  const mutationOptions = getPostEvaluatePizzaAdvancedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postGetNextPizza = (
  postGetNextPizzaBody: BodyType<PostGetNextPizzaBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostGetNextPizza200>(
    {
      url: `/api/admin/pizzas/next`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetNextPizzaBody,
      signal,
    },
    options,
  );
};

export const getPostGetNextPizzaMutationOptions = <
  TError = ErrorType<PostGetNextPizza500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGetNextPizza>>,
    TError,
    { data: BodyType<PostGetNextPizzaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGetNextPizza>>,
  TError,
  { data: BodyType<PostGetNextPizzaBody> },
  TContext
> => {
  const mutationKey = ["postGetNextPizza"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGetNextPizza>>,
    { data: BodyType<PostGetNextPizzaBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postGetNextPizza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostGetNextPizzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGetNextPizza>>
>;
export type PostGetNextPizzaMutationBody = BodyType<PostGetNextPizzaBody>;
export type PostGetNextPizzaMutationError = ErrorType<PostGetNextPizza500>;

export const usePostGetNextPizza = <
  TError = ErrorType<PostGetNextPizza500>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGetNextPizza>>,
      TError,
      { data: BodyType<PostGetNextPizzaBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGetNextPizza>>,
  TError,
  { data: BodyType<PostGetNextPizzaBody> },
  TContext
> => {
  const mutationOptions = getPostGetNextPizzaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postGetPrevPizza = (
  postGetPrevPizzaBody: BodyType<PostGetPrevPizzaBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PostGetPrevPizza200>(
    {
      url: `/api/admin/pizzas/prev`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetPrevPizzaBody,
      signal,
    },
    options,
  );
};

export const getPostGetPrevPizzaMutationOptions = <
  TError = ErrorType<PostGetPrevPizza500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGetPrevPizza>>,
    TError,
    { data: BodyType<PostGetPrevPizzaBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGetPrevPizza>>,
  TError,
  { data: BodyType<PostGetPrevPizzaBody> },
  TContext
> => {
  const mutationKey = ["postGetPrevPizza"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGetPrevPizza>>,
    { data: BodyType<PostGetPrevPizzaBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postGetPrevPizza(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostGetPrevPizzaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGetPrevPizza>>
>;
export type PostGetPrevPizzaMutationBody = BodyType<PostGetPrevPizzaBody>;
export type PostGetPrevPizzaMutationError = ErrorType<PostGetPrevPizza500>;

export const usePostGetPrevPizza = <
  TError = ErrorType<PostGetPrevPizza500>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGetPrevPizza>>,
      TError,
      { data: BodyType<PostGetPrevPizzaBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGetPrevPizza>>,
  TError,
  { data: BodyType<PostGetPrevPizzaBody> },
  TContext
> => {
  const mutationOptions = getPostGetPrevPizzaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getPizzaById = (
  pizzaId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GetPizzaById200>(
    { url: `/api/admin/pizzas/${pizzaId}`, method: "GET", signal },
    options,
  );
};

export const getGetPizzaByIdQueryKey = (pizzaId: string) => {
  return [`/api/admin/pizzas/${pizzaId}`] as const;
};

export const getGetPizzaByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPizzaById>>,
  TError = ErrorType<GetPizzaById404 | GetPizzaById500>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPizzaByIdQueryKey(pizzaId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPizzaById>>> = ({
    signal,
  }) => getPizzaById(pizzaId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!pizzaId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPizzaById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPizzaByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPizzaById>>
>;
export type GetPizzaByIdQueryError = ErrorType<
  GetPizzaById404 | GetPizzaById500
>;

export function useGetPizzaById<
  TData = Awaited<ReturnType<typeof getPizzaById>>,
  TError = ErrorType<GetPizzaById404 | GetPizzaById500>,
>(
  pizzaId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaById>>,
          TError,
          Awaited<ReturnType<typeof getPizzaById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPizzaById<
  TData = Awaited<ReturnType<typeof getPizzaById>>,
  TError = ErrorType<GetPizzaById404 | GetPizzaById500>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPizzaById>>,
          TError,
          Awaited<ReturnType<typeof getPizzaById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPizzaById<
  TData = Awaited<ReturnType<typeof getPizzaById>>,
  TError = ErrorType<GetPizzaById404 | GetPizzaById500>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPizzaById<
  TData = Awaited<ReturnType<typeof getPizzaById>>,
  TError = ErrorType<GetPizzaById404 | GetPizzaById500>,
>(
  pizzaId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPizzaById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPizzaByIdQueryOptions(pizzaId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
